import React from "react"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import { Paper, CircularProgress, SelectField, MenuItem} from "material-ui"
import DateRangeSelect_SelectWeek from "../../../../components/common/DateRangeSelect_SelectWeek"
import { EDayOfWeek, IDate, IPayrollPayCalendar, IScheduleDocument } from "../../../../models"
import moment from "moment"
import WorkforceAssessmentPositionComparisonGraph from "./WorkforceAssessmentPositionComparisonGraph"
import * as api from "../../../../api"
import HierarchySettingsStore from "../../../../stores/HierarchySettingsStore"
import { IWorkforceAssessmentDashboard, IWorkforceAssessmentDashboardHierarchySummary, IWorkforceAssessmentDashboardJobSummary, IWorkforceAssessmentDashboardPositionSummary } from "../../../../models/data/dashboard/WorkforceAssessment/WorkforceAssessmentDashboard"
import numeral from "numeral"
import WorkTypePieChart from "./WorkTypePieChart"
import * as utils from "../../../../helpers/utils"
import WorkforceAssessmentHierarchyJobTable from "./WorkforceAssessmentHierarchyJobTable"
import ScheduleBudgetCostSavingsDrawer from "../../../../components/schedule/detail/ScheduleBudgetCostSavingsDrawer"
import { IScheduleBudgetInfo } from "../../../../models/data/scheduling/ScheduleBudgetInfo"
import AccountStore from "../../../../stores/AccountStore"
import WorkforceAssessmentPositionsTable from "./WorkforceAssessmentPositionsTable"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IProps {
}

interface IState {
    loading: boolean
    calculating: boolean
    startDate: IDate
    endDate: IDate
    data: IWorkforceAssessmentDashboard
    showSavingsDrawer: boolean
    selectedScheduleBudgetInfo: IScheduleBudgetInfo
    selectedCostSavingsDrawerName: string
    activeDashboard: string
}

const subTitleClass = {
    textTransform: "uppercase",
    fontSize: "15pt",
    textAlign: "center",
    marginBottom: 20, 
    weight: "bold",
}

const titleClass = {
    marginTop:50,
    fontSize: 65,
    textAlign: "center",
}

export default class WorkforceOptimization extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)
        const calcualteStartEndDateLocalUTCFormat = this.getCalcualteStartEndDateLocalUTCFormat()
        this.state = {
            loading: true,
            calculating: false,
            startDate: localStorage.getItem("findd_dashboard_startDate") ? localStorage.getItem("findd_dashboard_startDate") : calcualteStartEndDateLocalUTCFormat.calcualteStartDateLocalUTCFormat,
            endDate: localStorage.getItem("findd_dashboard_endDate") ? localStorage.getItem("findd_dashboard_endDate") : calcualteStartEndDateLocalUTCFormat.calcualteEndDateLocalUTCFormat,
            data: null,
            showSavingsDrawer: false,
            selectedScheduleBudgetInfo: null,
            selectedCostSavingsDrawerName: null,
            activeDashboard: "wfo"
        }
        autobind(this)
    }

    getCalcualteStartEndDateLocalUTCFormat() {
        let calcualteStartDateLocalUTCFormat = null
        let calcualteEndDateLocalUTCFormat = null

        calcualteStartDateLocalUTCFormat = moment().startOf("day").utc(true).format()
        calcualteEndDateLocalUTCFormat = moment().add(1, "week").utc(true).format()

        return { calcualteStartDateLocalUTCFormat, calcualteEndDateLocalUTCFormat }
    }

    componentDidMount() {
        document.title = `${strings.Dashboard} | Workforce Assessment`
        HierarchySettingsStore.on("global_change", this.fetchData)        
        this.fetchData()
    }

    fetchData(){
        this.setState({data: null, loading: true},()=>{
            api.getWorkforceAssessmentDashboard(HierarchySettingsStore.getGlobalLevelItemFilterId(), this.state.startDate.toString(), this.state.endDate.toString()).then(result => {
                this.setState({data: result.data, loading: false})
            });    
        })
    }

    componentWillUnmount() {
        HierarchySettingsStore.removeListener("global_change", this.fetchData)
    }

    render() {
        const data = this.state.data        
        const globalHierarchyName = HierarchySettingsStore.globalLevelItemFilter ? HierarchySettingsStore.globalLevelItemFilter.Label : AccountStore.CurrentAccount.Name
        const divider = <hr style={{color: "#efefef", marginTop:20, marginBottom: 20}}/>
        console.log("data.ScheduleBudgetInfo.WorkTypeInfo:")
        if(data){
            console.log(data.ScheduleBudgetInfo.WorkTypeInfo)
        }

        return (
            <div>
                <DateRangeSelect_SelectWeek
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                sameDatesAllowed
                                selectedPayrollPayCalendar={{
                                    PayPeriodStartDay: EDayOfWeek.Monday,
                                    PayPeriodDayStartTime24Hour: 0,
                                    PayPeriodNumberOfWeeks: 1
                                } as IPayrollPayCalendar}
                                handleChange={(startDate, endDate, isValid) =>
                                    isValid &&
                                    this.setState({
                                        calculating: false,
                                        startDate: startDate,
                                        endDate: endDate
                                    },()=>{
                                        localStorage.setItem("findd_dashboard_startDate", startDate.toString())
                                        localStorage.setItem("findd_dashboard_endDate", endDate.toString())
                                        this.fetchData()
                                    })
                                }
                            />   
                {divider}
                {data && !this.state.loading &&
                    <div style={{marginTop: 40}}>
                        <div style={{display: "grid", }}>
                            <div style={{gridRow: 1, gridColumn: 1, ...subTitleClass}}>
                                cost savings potential
                            </div>
                            <div style={{gridRow: 1, gridColumn: 2, ...subTitleClass}}>
                                work type
                            </div>
                            {data.ScheduleBudgetInfo.FillRateInfo.FillRate !== 0 && 
                                <div style={{gridRow: 1, gridColumn: 3, ...subTitleClass}}>
                                    fill rate
                                </div>
                            }
                            <div style={{gridRow: 1, gridColumn: 4, ...subTitleClass}}>
                                fte utilization
                            </div>
                            <div style={{gridRow: 1, gridColumn: 5, ...subTitleClass}}>
                                overtime rate
                            </div>

                            <div style={{gridRow: 2, gridColumn: 1, ...titleClass}}>
                                <div style={{display: "grid", alignItems: "center", gridTemplateColumns: "auto min-content", cursor: "pointer"}} 
                                onClick={()=>{
                                    this.setState({showSavingsDrawer: true, selectedCostSavingsDrawerName: globalHierarchyName, selectedScheduleBudgetInfo: data.ScheduleBudgetInfo})                                
                                }}>
                                    <div style={{gridColumn: 1, gridRow: 1}}>
                                        {data.ScheduleBudgetInfo.SavingsPotential && numeral(data.ScheduleBudgetInfo.SavingsPotential.TotalSavings).format('$0.0a')}                        
                                    </div>
                                    <div style={{gridColumn: 2, gridRow: 1}}>
                                        <i className="fa fa-info-circle" style={{fontSize: 15}} />  
                                    </div>
                                </div>                                                                                                                              
                            </div>
                            <div style={{gridRow: 2, gridColumn: 2, justifyContent: "center"}}>
                                <WorkTypePieChart workType={data.ScheduleBudgetInfo.WorkTypeInfo} />
                            </div>
                            {data.ScheduleBudgetInfo.FillRateInfo.FillRate !== 0 && 
                                <div style={{gridRow: 2, gridColumn: 3, ...titleClass}}>
                                    {utils.toPercentage(data.ScheduleBudgetInfo.FillRateInfo.FillRate)}
                                </div>
                            }
                            <div style={{gridRow: 2, gridColumn: 4, ...titleClass}}>
                                {utils.toPercentage(data.ScheduleBudgetInfo.FTEUtilizationInfo.Utilization)}
                            </div>
                            <div style={{gridRow: 2, gridColumn: 5, ...titleClass}}>
                                {utils.toPercentage(data.ScheduleBudgetInfo.OvertimeInfo.OvertimePercentageOfWhole)}
                            </div>
                        </div>
                        {divider}
                        <div style={{width: "100%"}}>
                            <div style={{...subTitleClass}}>
                                Facility & Department List
                            </div>

                            <WorkforceAssessmentHierarchyJobTable 
                                hierarchyItems={data.HierarchySummaries} 
                                jobItems={data.JobSummaries} 
                                onHierarchyRowClick={(item: IWorkforceAssessmentDashboardHierarchySummary)=>{
                                    this.setState({
                                        showSavingsDrawer: true, 
                                        selectedCostSavingsDrawerName: item.HierarchyName, 
                                        selectedScheduleBudgetInfo: item.ScheduleBudgetInfo}
                                    )
                                }} 
                                onJobRowClick={(item: IWorkforceAssessmentDashboardJobSummary)=>{
                                    this.setState({
                                        showSavingsDrawer: true, 
                                        selectedCostSavingsDrawerName: item.JobName, 
                                        selectedScheduleBudgetInfo: item.ScheduleBudgetInfo}
                                    )
                                }}                                     
                            />
                        </div>          
                        {divider}        
                        {false &&       
                            <div style={{display: "grid", alignContent: "center"}}>
                                <div style={{gridRow: 1, gridColumn: 1, ...subTitleClass}}>
                                    fill rate by position
                                </div>
                                <div style={{gridRow: 2, gridColumn: 1,}}>
                                    <WorkforceAssessmentPositionComparisonGraph
                                        data1={[105,95,123,92,92,93,94,145,115,100,100,121]}
                                        data2={[95,105,103,101,98,96,120,116,101,90,99,101]}
                                        //data3={[90,95,83,90,92,91,86,91,95,97,100,101]}
                                        label1={"RN"}
                                        label2={"CNA"}
                                        //label3={"Charge - RN"}
                                        positionSummaries={this.state.data.PositionSummaries}
                                    />
                                </div>
                                <div style={{gridRow: 1, gridColumn: 2, ...subTitleClass}}>
                                    position summary
                                </div>
                                <div style={{gridRow: 2, gridColumn: 2,}}>
                                    <WorkforceAssessmentPositionsTable 
                                        items={data.PositionSummaries} 
                                        onRowClick={(item: IWorkforceAssessmentDashboardPositionSummary)=>{
                                            this.setState({
                                                showSavingsDrawer: true, 
                                                selectedCostSavingsDrawerName: item.PositionName, 
                                                selectedScheduleBudgetInfo: item.ScheduleBudgetInfo}
                                            )
                                        }} 
                                    />
                                </div>                            
                            </div>
                        }
                    </div>
                }


                {this.state.loading &&
                    <div className="spinner">
                        <CircularProgress />
                    </div> 
                } 

                {this.state.showSavingsDrawer && this.state.selectedScheduleBudgetInfo &&
                    <ScheduleBudgetCostSavingsDrawer 
                        name={this.state.selectedCostSavingsDrawerName} 
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        bi={this.state.selectedScheduleBudgetInfo}      
                        open={this.state.showSavingsDrawer} 
                        handleClose={()=> this.setState({showSavingsDrawer: false})}
                    />
                }
            </div >
        )
    }
}